import styled from "styled-components";

import DefaultSuccessBanner from "features/shared/components/banners/success-banner/styles/SuccessBanner.styled";

import { Summary } from "features/shared/styles/typography/Summary.styled";

const StyledChecklistSection = styled.div`
  background-color: ${({ theme }) => theme.colors.base1};
  padding: 24px 0;
  height: 100%;
  min-height: 100vh;

  ${DefaultSuccessBanner} {
    margin-bottom: 24px;
  }

  > ${Summary} {
    padding-top: 24px;
  }
`;
export default StyledChecklistSection;
